// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1emJz","info":"PatientInfo_info__3sCiG"};